"use client"

// src/tokens/breakpoints.ts
var breakpoints = {
  sm: "30em",
  md: "48em",
  lg: "61em",
  xl: "80em",
  "2xl": "90em"
};

export {
  breakpoints
};
//# sourceMappingURL=chunk-LVSXNUER.mjs.map